import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { Const } from '../../../core/helpers/Const';
import {DialogBodyComponent, DialogRef} from '@fundamental-ngx/core/dialog';
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {UisService} from "../../../service/services/misc/uis/uis.service";
import {ButtonType} from "@fundamental-ngx/core";

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent {
    Const = Const;
	@Input() headerText: string;
	@Input() headerGlyph: IconProp;
	@Input() headerIcon: string;
	@Input() body: TemplateRef<any>;
	@Input() additionalErrorContent: TemplateRef<any>;
	@Input() validationFn: () => boolean = () => true;
	@Input() saveText: string;
	@Input() saveButtonType: ButtonType = 'emphasized';
	@Input() additionalFooterButtons: TemplateRef<any>;
	@Input() additionalHeaderButtons: TemplateRef<any>;
	@Input() cancelText = 'Cancel';
	@Input() showCancelButton = true;
	@Input() showSaveButton = true;
	@Input() showTopCancelButton = true;
	@Input() dialogClass: string;
	@Input() errorText: string;
	@Input() errorMsg: string;
	@Input() contentVisible = true;
	@Input() showFooter = true;
	@Input() isExpanded = false;

	@ViewChild('strip') private errorStripContainer: ElementRef;
	@ViewChild(DialogBodyComponent) private dialogBody: DialogBodyComponent;

	@Output() save: EventEmitter<Event> = new EventEmitter<Event>();

	@Output() cancel: EventEmitter<Event> = new EventEmitter<Event>();

  @Input() busy: any;

  constructor(public dialogRef: DialogRef, public uisService: UisService) {}

  focusErrorStrip() {
	    this.errorStripContainer.nativeElement.focus();
  }

  onCancel() {
	  this.cancel.emit();
	  this.dialogRef.dismiss('Cancel');
	  this.uisService.sendUISEvent(this.uisService.UIS_EVENT_TYPES.CANCEL_DIALOG + " - " + this.headerText,
		  {resource: this.headerText, path: this.dialogRef.data?.resource?.path});
  }

  scrollTop() {
	  if (this.dialogBody) {
		  this.dialogBody.elementRef.nativeElement.scrollTo({top: 0, behavior: 'instant'});
	  }
  }
}
